import React, { useRef } from 'react'
import { Form } from 'react-bootstrap'
import Select, { components } from 'react-select'
import { getIn, setIn } from 'formik'
import {
  DropdownIndicator,
  Menu,
  MultiValueContainer,
} from './FormSelectComponents'
import { isMobile } from '../helpers/index.js'
import TooltipOnHover from './TooltipOnHover'

const { Control, Group, Label } = Form
const customStyles = (isMulti, hasDropdownControlMenu, smallHeight) => ({
  menuList: base => ({
    ...base,
    maxHeight: isMulti && hasDropdownControlMenu ? '230px' : '300px',
  }),
  control: base => ({
    ...base,
    height: smallHeight ? '36px !important' : '',
    minHeight: smallHeight ? '36px !important' : '',
  }),
})

export default function FormSelect({
  field,
  form: {
    touched = {},
    errors = {},
    setFieldValue = () => {},
    setTouched = () => {},
  } = {},
  icon,
  options = [],
  groupProps = {},
  controlId,
  handleChange,
  isMulti = false,
  showSelectAll = false,
  isSearchable = false,
  disabled = false,
  isClearAble = false,
  hideSelectedOptions,
  placeholder = 'Select...',
  classNamePrefix = 'react-select',
  roundFormField = false,
  whiteFieldInput = false,
  increaseFontSize = false,
  defaultValue = null,
  closeMenuOnSelect = true,
  handleApply,
  hasDropdownControlMenu = false,
  smallHeight = false,
  useLabelAsPlaceholder = false,
  error,
  isAutomation = false,
  menuPlacement = 'auto',
  useChevronIndicator = false,
  ...props
}) {
  // console.log('errors', errors)
  const showError =
    (!!getIn(touched, field.name) && !!getIn(errors, field.name)) || error
  const wrapperRef = useRef(null)
  const selectRef = useRef(null)
  const isMobileBrowser = isMobile()
  var timer = null

  const onChange = value => {
    setFieldValue(field.name, value)
    if (handleChange) {
      if (isClearAble) {
        handleChange(value, selectRef)
      } else {
        handleChange(value)
      }
    }
  }

  const onFocus = () => {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
    timer = setInterval(() => {
      if (!wrapperRef || !wrapperRef.current) {
        clearInterval(timer)
        return
      }
      // let react_menu = wrapperRef.current.getElementsByClassName(
      //   `${classNamePrefix}__menu`
      // )
      // if (react_menu.length > 0) {
      // wrapperRef.current.style.marginBottom =
      //   react_menu[0].scrollHeight + 'px'
      // } else {
      //   wrapperRef.current.removeAttribute('style')
      // }
    }, 100)
  }

  const onBlur = () => {
    const _touched = setIn({ ...touched }, field.name, true)
    setTouched(_touched)
    if (props.handleBlur) {
      // console.log('inside props handleBlur form select')
      props.handleBlur()
    }
    if (props.handleApplyOnBlur) {
      props.handleApplyOnBlur(field.value)
    }
  }

  const onSelectAll = e => {
    e.preventDefault()
    e.stopPropagation()
    const newValue =
      !field.value || field.value.length < options.length ? [...options] : []
    setFieldValue(field.name, newValue)
  }

  const Option = props => {
    if (props.data.type === 'checkBox') {
      return (
        <div className='selectOptionCheckbox'>
          <components.Option {...props}>
            <div>
              <span>{props.data.label}</span>
            </div>
          </components.Option>
        </div>
      )
    } else if (props.data.type && props.data.type === 'button') {
      return (
        <div className='selectOptionButton'>
          <components.Option {...props}>
            <div>
              <span>{props.data.label}</span>
              <img src={`/images/icons/${props.data.icon}`} alt='' />
            </div>
          </components.Option>
        </div>
      )
    } else if (props.data.type && props.data.type === 'escalation') {
      return (
        <div className='selectOptionButton'>
          <components.Option {...props}>
            <div>
              <span>{props.data.label}</span>
              <TooltipOnHover
                delay={200}
                placement='right-start'
                isMobileBrowser={false}
                onMouseEnter={() => {}}
                component={
                  <ul style={{ paddingLeft: '1rem' }}>
                    {props.data.items.map((str, i) => (
                      <li key={i}>{str}</li>
                    ))}
                  </ul>
                }
              >
                <img
                  alt=''
                  className={'coverage-info-icon'}
                  src='/images/icons/info-black.png'
                  style={{ width: '12px', height: '15px' }}
                />
              </TooltipOnHover>
            </div>
          </components.Option>
        </div>
      )
    } else {
      return <components.Option {...props} />
    }
  }
  const ClearIndicator = props => {
    return (
      components.ClearIndicator && (
        <components.ClearIndicator {...props}>
          <div
            className={`${classNamePrefix}__dropdown-indicator-clearable-filter`}
          >
            <img src='/images/icons/close-icon.png' alt='' />
          </div>
        </components.ClearIndicator>
      )
    )
  }
  const ChevronDropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <img src='/images/icons/chevron-down.svg' alt='' />
        </components.DropdownIndicator>
      )
    )
  }
  const DropdownIndicatorClearable = props => {
    if (props.hasValue) {
      return null
    } else {
      return (
        components.DropdownIndicator && (
          <components.DropdownIndicator {...props}>
            {useChevronIndicator ? (
              <img src='/images/icons/chevron-down.svg' alt='' />
            ) : (
              <div
                className={`${classNamePrefix}__dropdown-indicator-carrot-filter`}
              >
                <img src='/images/icons/caret-down.svg' alt='' />
              </div>
            )}
          </components.DropdownIndicator>
        )
      )
    }
  }
  const ValueContainer = isMulti
    ? MultiValueContainer
    : components.ValueContainer
  return (
    <>
      <Group
        controlId={controlId || field.name}
        ref={wrapperRef}
        className={
          whiteFieldInput
            ? 'white-field-input'
            : roundFormField
            ? 'round-select-group'
            : increaseFontSize
            ? 'client-select-group'
            : isAutomation
            ? 'automation-time-select'
            : ''
        }
        style={isAutomation ? { marginBottom: '0' } : {}}
      >
        {props.label && (!useLabelAsPlaceholder || props.showLabel) ? (
          <Label className='form-label'>{props.label}</Label>
        ) : (
          <></>
        )}
        <Select
          components={{
            ...(isClearAble
              ? {
                  DropdownIndicator: DropdownIndicatorClearable,
                  IndicatorSeparator: () => null,
                  ValueContainer,
                  ClearIndicator,
                  Option,
                }
              : {
                  DropdownIndicator: useChevronIndicator
                    ? ChevronDropdownIndicator
                    : DropdownIndicator,
                  ValueContainer,
                  Option,
                }),
            ...(isMulti && hasDropdownControlMenu
              ? {
                  Menu,
                }
              : {}),
          }}
          className={`${classNamePrefix}-container ${
            showError ? 'is-invalid' : ''
          } ${
            selectRef &&
            selectRef.current &&
            selectRef.current.state.value &&
            classNamePrefix !== 'react-select'
              ? 'hasValue'
              : ''
          }`}
          classNamePrefix={classNamePrefix}
          styles={customStyles(isMulti, hasDropdownControlMenu, smallHeight)}
          hideSelectedOptions={
            hideSelectedOptions !== undefined ? !!hideSelectedOptions : !isMulti
          }
          defaultValue={defaultValue}
          {...field}
          inputId={controlId || field.name}
          ref={selectRef}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          isClearable={isClearAble}
          placeholder={useLabelAsPlaceholder ? props.label : placeholder}
          options={options}
          isMulti={isMulti}
          selectRef={selectRef}
          useLabelAsPlaceholder={useLabelAsPlaceholder}
          handleApply={handleApply}
          closeMenuOnSelect={closeMenuOnSelect}
          smallHeight={smallHeight}
          label={props.label}
          hasDropdownControlMenu={hasDropdownControlMenu}
          onSelectAll={showSelectAll ? onSelectAll : null}
          isSearchable={isSearchable}
          selectedAll={
            !!showSelectAll &&
            !!isMulti &&
            !!field.value &&
            field.value.length === options.length
          }
          isDisabled={disabled}
          menuPlacement={menuPlacement}
          // menuIsOpen={true}
        />
        {showError && (
          <Control.Feedback className='d-block' type='invalid'>
            {getIn(errors, field.name)}
          </Control.Feedback>
        )}
      </Group>
      {/* )} */}
    </>
  )
}
